package br.com.vvrefeicoes.portal.core.util

import kotlinx.browser.window

actual fun openPublicMonitor(code: String) {
    val baseUrl = window.location.href.substringBefore('#')
    window.open("$baseUrl#/monitor_pesquisa/$code", "_blank", "noopener,noreferrer")
}

actual fun publicMonitorCodeFromUrl(): String? =
    window.location.hash
        .removePrefix("#/monitor_pesquisa/")
        .takeIf { it.length == 16 && it.matches(Regex("[0-9a-fA-F]{16}")) }
